import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Helmet from "react-helmet";
import FadeLoader from "react-spinners/FadeLoader";
import * as Path from "routes/Path/index";
import Table from "components/Table";
import { Link, useNavigate } from "react-router-dom";
import { getContactList } from "store/contact/actions";
import { CONTACTUSPAGE } from "common/viewContent";
import Columns from "./Columns";

const List = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { CONTACTUS, loading, totalCount } = useSelector(
    (state) => state?.ContactUs
  );
  console.log(CONTACTUS, "CONTACTUS");

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [search_text, setSearch_text] = useState();
  const [contactList, setContactList] = useState([]);
  const [columns, setcolumns] = useState([{ dataField: "", text: "" }]);

  const [filter, setFilter] = useState({
    pageNo: currentPage,
    limit: pageSize,
    search_text: "",
  });

  const fetchData = async (filter) => {
    const payload = {
      ...filter,
      page: filter?.pageNo,
      record_count: filter?.limit,
    };
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          setContactList(res);
        }
      };
      dispatch(getContactList({ data: payload, callback }));
    } catch (error) {
      console.error(error, "<===err");
    }
  };
  const clearFilter = () => {
    setFilter((pre) => ({
      ...pre,
      pageNo: 1,
      search_text: "",
    }));
    setSearch_text("");
  };
  const onClickFilter = (e) => {
    e?.preventDefault();
    setFilter({
      ...filter,
      pageNo: 1,
      limit: pageSize,
      search_text: search_text,
    });
  };
  const handlePageChange = (pageNumber) => {
    console.log("pageNumber->", pageNumber);
    setCurrentPage(pageNumber);
  };
  const handleView = (data) => {
    navigate(`/admin/contact-us/detail`, {
      state: { message: data },
    });
  };
  useEffect(() => {
    fetchData(filter);
    setcolumns(Columns({ handleView, currentPage: filter?.pageNo, pageSize }));
  }, [filter]);

  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      <Helmet title={CONTACTUSPAGE.CURRENT_MODULE} />
      <section className="section">
        <div className="section-header">
          <h1>{CONTACTUSPAGE.CURRENT_MODULE}</h1>
          <div className="section-header-breadcrumb">
            <div className="breadcrumb-item active">
              <Link to={"/admin/" + Path.dashboard}>Dashboard</Link>
            </div>
            <div className="breadcrumb-item">
              {CONTACTUSPAGE.CURRENT_MODULE}{" "}
            </div>
          </div>
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="card-header">
                  <h2 className="section-title">{CONTACTUSPAGE.TOP_CONTENT}</h2>
                </div>
              </div>
              <div className="col-12">
                <form onSubmit={onClickFilter}>
                  <div className="card-header">
                    <div className="col-lg-4 col-sm-12 col-md-12 my-2 px-0">
                      <input
                        className="form-control"
                        name="search_text"
                        onChange={(e) => setSearch_text(e.target.value)}
                        value={search_text}
                        placeholder="Search using name, email..."
                      />
                    </div>
                  </div>
                  <div className="col-12 my-2 gap-4 ">
                    <div className="d-flex gap-4">
                      <button type="submit" className="btn btn-primary btn-lg">
                        Search
                      </button>
                      <button
                        onClick={() => clearFilter()}
                        type="button"
                        className="btn btn-primary btn-lg"
                      >
                        Clear Search
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {!loading && CONTACTUS?.data?.length > 0 && (
            <Table
              data={CONTACTUS?.data}
              columns={columns}
              setFilter={setFilter}
              handleTableChange={handlePageChange}
              totalCount={totalCount}
              filter={filter}
            />
          )}
          {CONTACTUS.length === 0 && (
            <p style={{ textAlign: "center" }}>No Message Found</p>
          )}
        </div>
      </section>
    </>
  );
};
export default List;
